export default __webpack_public_path__ + "static/media/discount2.ffd8b77e.jpg";